import { render } from "./TokenTableUpdater.vue?vue&type=template&id=b380a64e&scoped=true"
import script from "./TokenTableUpdater.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenTableUpdater.vue?vue&type=script&setup=true&lang=js"

import "./TokenTableUpdater.vue?vue&type=style&index=0&id=b380a64e&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b380a64e"],['__file',"resources/js/components/TokenTableUpdater.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b380a64e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b380a64e', __exports__)) {
    api.reload('b380a64e', __exports__)
  }
  
  module.hot.accept("./TokenTableUpdater.vue?vue&type=template&id=b380a64e&scoped=true", () => {
    api.rerender('b380a64e', render)
  })

}


export default __exports__